import React, { useEffect, useState } from 'react';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import { SchoolEvent } from 'models/event';
import { getSchoolEventReport } from 'services/school';
import Loader from 'components/loader';
import './EventMatchReport.scss';

interface Props { event: SchoolEvent; activeSchoolId: string; }

export default function EventMatchReport({ event, activeSchoolId }: Props) {
   const [content, setContent] = useState('');
   const [isLoading, setIsLoading] = useState(true);
   const [loadError, setLoadError] = useState(false);

   useEffect(() => {
      let active = true;
      setIsLoading(true);
      getSchoolEventReport(activeSchoolId, event.id)
         .then(report => { if (active) setContent(String(report?.content || '').trim()); })
         .catch(() => { if (active) setLoadError(true); })
         .finally(() => { if (active) setIsLoading(false); });
      return () => { active = false; };
   }, [activeSchoolId, event.id]);

   if (isLoading) return <div className='event-match-report__loading'><Loader /></div>;
   if (loadError) return <section className='event-match-report__empty' role='alert'><ArticleRoundedIcon /><h2>Match report could not be loaded</h2><p>Please refresh the page and try again.</p></section>;
   if (!content) return <section className='event-match-report__empty'><ArticleRoundedIcon /><h2>No match report yet</h2><p>The report will appear here when it is published by the school.</p></section>;
   return <article className='event-match-report'><div className='event-match-report__heading'><ArticleRoundedIcon /><div><span>Match report</span><h2>How the event unfolded</h2></div></div><div className='event-match-report__content' dangerouslySetInnerHTML={{ __html: content }} /></article>;
}
